var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{attrs:{"excel":_vm.isButton_(_vm.scrId, 'EX'),"customExcel":_vm.excelFunc,"columns":_vm.columns,"rows":_vm.rows,"index":"","height":"100%","paging":"","pageUnit":_vm.pageUnit_,"pageArray":_vm.screen.pageArray,"totalSize":_vm.totalSize_},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }